<template>
  <div ref="sticky-wrapper" class="sticky-wrapper" :class="{'sticked': sticked, 'unpinned': unpinned, 'pinned': !unpinned}">
    <div v-if="height" class="sticky-helper" :style="{
      'height': `${height}px`
      }"></div>

    <div class="sticky-element" :style="{
      'position': position,
      'top': `${fixedOffset}px`,
      'width': `${width}%`,
      'transition': fixedTransition
    }">
      <slot :scrollTop="lastScrollTop"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      offset: {
        type: Number,
        required: false,
        default: 0
      },
      width: {
        type: Number,
        required: false,
        default: null
      },
      transition: {
        type: Boolean,
        required: false,
        default: false
      },
    },
    data() {
      return {
        height: 0,
        sticked: false,
        unpinned: false,
        lastScrollTop: 0
      }
    },
    computed: {
      position() {
        let position = 'relative'

        if (!this.sticked && this.height) {
          position = 'absolute'
        }

        if (this.sticked && this.height) {
          position = 'fixed'
        }

        return position
      },
      fixedOffset() {
        return this.sticked ? this.offset : 0
      },
      fixedTransition() {
        if (this.transition) {
          return 'top 250ms ease-in-out'
        } else {
          return 'unset'
        }
      }
    },
    methods: {
      toggleStickPin() {
        let parentElTop = this.$refs['sticky-wrapper'].getBoundingClientRect().top
        let st = window.pageYOffset || document.documentElement.scrollTop

        if (parentElTop < this.offset && !this.sticked) {
          this.sticked = true
          this.$emit('sticked');
        } else if (parentElTop >= this.offset && this.sticked) {
          this.sticked = false
          this.$emit('unsticked');
        }

        if (this.sticked && st - this.lastScrollTop > 30 && !this.unpinned) {
          this.unpinned = true
          this.$emit('unpinned');
        } else if (this.sticked && st - this.lastScrollTop < 0 && this.unpinned) {
          this.unpinned = false
          this.$emit('pinned');
        }

        this.lastScrollTop = st <= 0 ? 0 : st

      },
      calcHeight() {
        if (!this.sticked) {
          this.height = this.$el.lastElementChild.offsetHeight
        }
      }
    },
    created() {
      window.addEventListener("scroll", this.toggleStickPin, {
        passive: false
      });

      window.addEventListener("resize", this.calcHeight, {
        passive: false
      });
    },
    mounted() {
      window.addEventListener('load', () => {
        this.calcHeight()
        this.toggleStickPin()
      }, {
        passive: false
      })
    },
    destroyed() {
      window.removeEventListener("scroll")
      window.removeEventListener("resize")
    }
  }
</script>

<style lang="scss">
  .sticky-wrapper {
    position: relative;

    .sticky-helper {
      position: relative;
    }

    .sticky-element {
      position: relative;
      left: 0;
      right: 0;
    }

    &.sticked {
      .sticky-element {
        z-index: 100;
      }
    }
  }
</style>